import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { RecipientsApi, type RecipientResponse, type UpdateRecipientRequest } from '@shared/api';
import { Constants } from '@shared/constants';

const updateRecipientEffect = createEffect((request: UpdateRecipientRequest) => RecipientsApi.updateRecipient(request));
const clearEvent = createEvent();

const $dataStore = createStore<RecipientResponse | null>(null)
  .on(updateRecipientEffect.done, (_, data) => data.result.data ?? null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(updateRecipientEffect.pending, (_, data) => data)
  .on(updateRecipientEffect.fail, () => false)
  .on(updateRecipientEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<{ message: string; errorCode?: string | null } | null>(null)
  // .on(updateRecipientEffect, () => null)
  .on(updateRecipientEffect.fail, (_, data) => {
    const error = ApiUtils.getApiErrorData(data.error, 'Something went wrong while updating Recipient. Please try again.');
    return Constants.VOP_ERROR_CODES.includes(error.errorCode || '') ? error : { message: error.message };
  })
  .on(updateRecipientEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error?.errorCode ? null : error?.message));

export const $recipientUpdateStore = {
  events: {
    updateRecipient: updateRecipientEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
